import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, ViewEncapsulation } from '@angular/core';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'member-community-toast',
  templateUrl: './community-toast.component.html',
  styleUrls: ['./community-toast.component.css'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('flyInOut', [
      state('inactive', style({
        opacity: 0,
      })),
      transition('inactive => active', [
          style({
            'height': '0',
            'padding-top': '0',
            'padding-bottom': '0',
            'margin-top': '0',
            'margin-bottom': '0',
            'opacity': '0'
          }),
          animate('.4s ease', style({
            'height': '*',
            'padding-top': '*',
            'padding-bottom': '*',
            'margin-top': '*',
            'margin-bottom': '*',
            'opacity': '1'
          })),
        ]
      ),
      transition('active => removed', [
        style({
          'height': '*',
          'padding-top': '*',
          'padding-bottom': '*',
          'margin-top': '*',
          'margin-bottom': '*',
          'opacity': '1'
        }),
        animate('.5s ease', style({
          height: '0',
          'padding-top': '0',
          'padding-bottom': '0',
          'margin-top': '0',
          'margin-bottom': '0',
          'opacity': '0'
        })),
      ]),
    ]),
  ],
})
export class CommunityToastComponent extends Toast  {

  // constructor is only necessary when not using AoT
  constructor(protected override toastrService: ToastrService, public override toastPackage: ToastPackage) {
    super(toastrService, toastPackage);
  }

  action(event: Event) {
    event.stopPropagation();
    this.toastPackage.triggerAction();
    return false;
  }

}
